// DO NOT PUT SECRETS IN HERE!!!
const production = {
  RSS_LINKS_URL: "https://cal.read.ai",
  FRONTEND_URL: "https://app.read.ai",
  INTERNAL_API_URL: "https://app-backend.infra.read.ai",
  api: {
    HOST: "https://api.read.ai",
  },
  apps: {
    meet: {
      CLIENT_ID:
        "766098389391-arnnrsjat8leug7ab7e0cdm5a1n58tbc.apps.googleusercontent.com",
    },
  },
  tracking: {
    // This is a different property than the staging and dev tags
    GOOGLE_ID: "G-2Y1H5ZJMBK",
    MIXPANEL_ID: "68e743b21f2eb5cbbfd12657136457ad",
    LINKED_IN_PARTNER_ID: "4030676",
    MIXPANEL_VERBOSE_LOG: true,
    STATSIG_KEY: "client-5rDNQDOcT7Yt6ZTWHVfNzpkY1kHdmfijSlRx83EYj9e",
  },
};

export type Config = typeof production;
export default production;
